module.exports = __webpack_public_path__ + "img/coupon-mockup-3.4cc223fa.png";